import * as yup from 'yup'

export const formValidationSchema = yup
  .object({
    name: yup.string().required('Campo obligatorio'),
  })
  .required()
